export default (amount: number, currency: string): string => {
  const amountString = String(amount / 100).replace('-', '+');
  const currencyString = currency.toUpperCase();
  const amountDecimals = amountString.slice(-2);

  return amount
    ? `${amountString.slice(0, -2)}${amountDecimals} ${currencyString}`
    : `${amountString} ${currencyString}`;
};
